import React, { Component } from 'react';
import PhotosLoading from './PhotosLoading';
import { withRouter, RouteComponentProps } from 'react-router';
import { IonRow, IonCol, IonIcon } from '@ionic/react';
import { arrowForward, addOutline } from 'ionicons/icons';

type Props = RouteComponentProps<{}> & {
  loading: boolean;
  photos: any;
  photoDetailFn: any;
  galleryFn: any;
  addPhoto: any;
  parkCode: string;
}

class PreviewGallery extends Component<Props> {
  render() {
    if (!this.props.photos || (this.props.photos && this.props.photos.length === 0)) {
      return (
        <IonRow>
          <IonCol size-lg="2" size-md="2" size-sm="4" size-xs="4">
            <div
              onClick={() => {this.props.addPhoto(this.props.parkCode)}}
              className="image-container view-more-button">
                <IonIcon icon={addOutline} />
                <div className="small-font">Add Photos</div><br />
            </div>
          </IonCol>
        </IonRow>
      );
    }
    if (this.props.loading) {
      return (<PhotosLoading loading={this.props.loading} />);
    } else {
      return (
        <>
          <IonRow>
            {this.props.photos && this.props.photos.map((item: any, index: number) => {
              if (index >= 5) {
                return '';
              }
              const val = `url(${item.url}), url('../../../assets/img/not-found.png')`;
              return (
                <IonCol key={index} size-lg="2" size-md="2" size-sm="4" size-xs="4">
                  <div
                    onClick={() => this.props.photoDetailFn(this.props.parkCode, item.id)}
                    className="image-container"
                    style={{"backgroundImage": val, "backgroundSize": "100% 100%", "backgroundRepeat": "no-repeat"}}></div>
                </IonCol>
              )
            })}
            {this.props.photos && this.props.photos.length > 5 ? <>
              <IonCol size-lg="2" size-md="2" size-sm="4" size-xs="4">
                  <div 
                    onClick={this.props.galleryFn(this.props.parkCode)}
                    className="image-container view-more-button">
                      
                      <IonIcon icon={arrowForward} />
                      <div className="small-font">View More</div><br />
                  </div>
                </IonCol>
            </> : <></> }
          </IonRow>
        </>
      );
    }
  }
};

export default withRouter(PreviewGallery);
